import validate from "validate.js";
import { prerequisites } from "./validators";

validate.validators.prerequisites = prerequisites;

export default validate;
